import React, { useRef, useReducer, useEffect } from "react";
import ReactDOM from "react-dom";
import reducer from "./reducer";
import styles from "./LightBoxModal.module.scss";

const Controls = ({ onClose }) => {
  return (
    <div>
      <button
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onClose();
        }}
        className={styles.modalClose}
      >
        <svg className={styles.modalCloseIcon} viewBox="0 0 40 40">
          <path d="M 10,10 L 30,30 M 30,10 L 10,30" />
        </svg>
      </button>
      <button
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onClose();
        }}
        className={styles.modalClose}
      >
        <svg className={styles.modalCloseIcon} viewBox="0 0 40 40">
          <path d="M 10,10 L 30,30 M 30,10 L 10,30" />
        </svg>
      </button>
    </div>
  );
};

const initialState = {
  imageSize: {},
  viewportSize: {},
  position: {},
  zoom: {},
  scale: 0,
  isLoaded: false,
  isZoomedIn: false,
};

const LightBoxModal = ({ imageUrl, close }) => {
  const imageRef = useRef<HTMLImageElement>();
  const trackIsInMoveRef = useRef(false);
  const [state, dispatch] = useReducer(reducer, initialState);
  const { isLoaded, isInMove, scale, isZoomedIn, imageSize, position } = state;

  useEffect(() => {
    imageRef.current = new Image();
    imageRef.current.src = imageUrl;
    imageRef.current.onload = () => {
      const { naturalWidth: width, naturalHeight: height } =
        imageRef?.current as HTMLImageElement;
      dispatch({
        type: "LOADED",
        imageSize: {
          width,
          height,
        },
      });
    };
    return () => {
      if (imageRef?.current) {
        imageRef.current.onload = null;
      }
    };
  }, [imageUrl]);

  // viewport size
  useEffect(() => {
    const updateViewport = () => {
      dispatch({
        type: "VIEWPORT_SIZE_CHANGED",
        viewportSize: {
          width: window.innerWidth,
          height: window.innerHeight,
        },
      });
    };
    updateViewport();
    window.addEventListener("resize", updateViewport);
    return () => {
      window.removeEventListener("resize", updateViewport);
    };
  }, []);

  // block scroll
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  // move
  const handleDragStart = (event) => {
    event.preventDefault();
    document.addEventListener("mousemove", handleDragMove);
    document.addEventListener("mouseup", handleDragEnd);
    dispatch({
      type: "MOVE_STARTED",
      point: {
        x: event.pageX,
        y: event.pageY,
      },
    });
  };

  const handleDragMove = (event) => {
    event.preventDefault();
    trackIsInMoveRef.current = true;
    dispatch({
      type: "MOVE",
      point: {
        x: event.pageX,
        y: event.pageY,
      },
    });
  };

  const handleDragEnd = () => {
    document.removeEventListener("mousemove", handleDragMove);
    document.removeEventListener("mouseup", handleDragEnd);
    dispatch({ type: "MOVE_ENDED" });
  };

  const handleClick = (event) => {
    event.stopPropagation();
    if (!trackIsInMoveRef.current) {
      dispatch({
        type: "TOGGLE_ZOOM",
        point: { x: event.clientX, y: event.clientY },
      });
    }
    trackIsInMoveRef.current = false;
  };

  return ReactDOM.createPortal(
    <aside className={styles.modalCover} onClick={close}>
      <Controls onClose={close} />
      <div className={styles.modal}>
        {isLoaded && (
          <img
            onClick={handleClick}
            onMouseDown={handleDragStart}
            src={imageUrl}
            style={{
              transform: [
                `translate3d(${position.x}px, ${position.y}px, 0px)`,
                `scale(${scale})`,
              ].join(" "),
              transformOrigin: "left top",
              cursor: isInMove
                ? "grabbing"
                : isZoomedIn
                ? "zoom-out"
                : "zoom-in",
              transition: !isInMove ? "transform 0.3s" : undefined,
              width: imageSize.width,
              height: imageSize.height,
            }}
          />
        )}
      </div>
    </aside>,
    document.body
  );
};
export default LightBoxModal;
